import React from 'react';

import SportsDefaultTitle from '@swf/components/SportsDefaultTitle/SportsDefaultTitle';

import Maintenance from './Maintenance/Maintenance';

export const SportsMaintenance = () => (
  <>
    <SportsDefaultTitle />
    <Maintenance />
  </>
);

export default SportsMaintenance;
